import { Outlet, Navigate, useLocation } from "react-router-dom";

export default function LogoOnlyLayout() {
  const { pathname } = useLocation();

  const isPublicJoin = pathname.startsWith("/join");
  const isWorkoutDisplay = Boolean(pathname.match("/WorkoutDisplay"));

  if (
    localStorage.getItem("token") &&
    !isWorkoutDisplay &&
    !isPublicJoin
  ) {
    return <Navigate to="/dashboard"> </Navigate>;
  }
  return <Outlet />;
}
